import React from 'react';
import CurrencyInput from 'react-currency-input-field';

class MoneyInput extends React.Component {
  state = {
    key: '0', // used to force re-mount of <CurrencyInput> if value props get out of sync
    localCents: 0
  };

  render = () => {
    const {
      name,
      valueCents,
      className = this.props.newStyles ? 'simple-input-new' : 'simple-input',
      disabled = false,
    } = this.props;
    const inputProps = {
      name,
      className,
      disabled,
    };

    // direct control over value causes cursor jumping issues, but is ok if input is disabled
    if (disabled) {
      inputProps['value'] = this.centsToDollars(this.props.valueCents);
    }

    return <CurrencyInput
      {...inputProps} 
      key={this.state.key}
      defaultValue={this.centsToDollars(valueCents)}
      decimalsLimit={2}
      onValueChange={(value) => this.handleChangeNew(value)}
    />;
  };

  centsToDollars(cents) {
    return cents < 10
        ? `.0${cents}`
        : `${cents}`.replace(/(\d{0,2})$/, '.$1');
  }

  dollarToCents(dollars) {
    return Math.round(dollars * 100)
  }

  componentDidMount() {
    this.setState({ localCents: this.props.cents, key: this.props.cents });
  }

  componentDidUpdate() {
    // if parent prop val ever gets out of sync with component...
    if (this.state.localCents !== this.props.valueCents) {
      this.setState({ localCents: this.props.valueCents, key: this.props.valueCents });
    }
  }

  handleChangeNew = (value) => {
    // if non-numeric input then we get undefined. Default to 0
    if (value === undefined) {
      value = 0
    }
    const cents = this.dollarToCents(value);
    this.setState({localCents: cents})
    if ('onChange' in this.props) this.props.onChange(cents);
  }

}

export default MoneyInput;



// WEBPACK FOOTER //
// ./src/components/form/MoneyInput.js